const EVENT_TYPE_MAPPING = {
  training: 'Ausbildung',
  refresher: 'Refresher',
  introduction: 'Einführung',
  qaworkshop: 'Q&A-Workshop'
}

export default (eventTypeKey) => {
  return EVENT_TYPE_MAPPING[eventTypeKey] || eventTypeKey
}
